import { missingValuePlaceholder } from '@utils/constants';

interface IGetFullName {
  firstName?: string | null;
  lastName?: string | null;
}

export const getFullName = ({ firstName, lastName }: IGetFullName) =>
  `${firstName ?? ''} ${lastName ?? ''}`.trim() || missingValuePlaceholder;
